import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5H9.48062L11.4806 5H23V13.8464C21.8077 12.4127 20.0104 11.5 18 11.5C14.4101 11.5 11.5 14.4102 11.5 18C11.5 19.0821 11.7644 20.1025 12.2322 21H1V2.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.9083 18.0021L19.05 13.0879L17.6277 14.494L20.1073 17.0021L12.998 17.0021V19.0021L20.1073 19.0021L17.6277 21.5102L19.05 22.9163L23.9083 18.0021Z"}}]};

const FolderExportFilled = Vue.extend<IconProps>({
  name: 'FolderExportFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'folder-export-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FolderExportFilled;
